import { query } from 'atomic-layout';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  margin: 0 auto;
  max-width: 1280px;
  max-height: 560px;
  border-bottom-right-radius: 120px;
  background-color: ${props => props.theme.colors.stone[500]};

  h1 {
    line-height: 56px;
  }

  @media ${query({ to: 'md' })} {
    width: 100%;
    max-width: 100%;
    max-height: unset;
    flex-direction: column;
    margin-bottom: 0;
    border-bottom-right-radius: 60px;

    h1 {
      line-height: 44px;
    }

    h6,
    a {
      line-height: 24px;
    }

    img:first-child {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
`;

export const ImageContainer = styled.div`
  max-width: 100%;
  min-width: 220px;
  position: relative;

  & > span {
    width: 100% !important;
    height: 100% !important;
    position: unset !important;
  }

  img {
    object-fit: cover;
    object-position: right;
  }
`;

export const MobileImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-self: center;
  width: auto;
  height: 321px;
  margin-top: -200px;
`;

export const RightSideContainer = styled.div`
  flex: 1;
  display: flex;
  min-width: 400px;
  flex-direction: column;
  align-items: flex-start;
  margin: 118px 112px 126px 42px;

  h1,
  h6,
  div > a,
  p {
    color: ${props => props.theme.colors.display[0]};
  }

  p {
    margin-top: 8px;
    margin-bottom: 24px;
    font-size: 20px;
    line-height: 30px;
  }

  @media ${query({ to: 'lg' })} {
    margin-right: 64px;
  }

  @media ${query({ to: 'md' })} {
    min-width: unset;
    margin: 24px 24px 40px 24px;
    p {
    }
  }
`;
